import { useQuery } from '@tanstack/react-query'
import type { UseQueryResult } from '@tanstack/react-query'

import { queryKeys } from '../../../../config/queryKeys'
import { getPlayerRecentGameStats } from '../../../../services/player/playerGameStats'
import { ALL_SPORTS } from '../constants'
import type { GameStat, StatsRole } from '../types'

export interface UsePlayerRecentGamesArgs {
  playerId?: string
  sportId: string | null
  role: StatsRole
  /** ANDed into the query's own gate (e.g. wait for the role to resolve). */
  enabled?: boolean
}

/** The player's latest games for one sport + role. Off for All Sports. */
export const usePlayerRecentGames = ({
  playerId,
  sportId,
  role,
  enabled = true,
}: UsePlayerRecentGamesArgs): UseQueryResult<GameStat[], Error> => {
  'use memo'

  return useQuery({
    queryKey: queryKeys.playerStats.recentGames(playerId, sportId, role),
    queryFn: () =>
      getPlayerRecentGameStats({
        playerId: playerId as string,
        sportId: sportId as string,
        role,
      }),
    enabled:
      enabled &&
      Boolean(playerId) &&
      sportId !== null &&
      sportId !== ALL_SPORTS,
  })
}

export default usePlayerRecentGames
